module.exports = __webpack_public_path__ + "img/case-logo-07.e6d47f89.png";